export default __webpack_public_path__ + "static/media/PROCESSMETHOD_CASTING_DIE.75b85ada.png";